var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "component-wait" },
    [
      _c(
        "el-tabs",
        {
          staticClass: "wait-tab",
          staticStyle: { "padding-left": "10px" },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", {
            attrs: {
              label: _vm.$t("panel.component_hidden"),
              name: "component-area",
            },
          }),
          _c("el-tab-pane", {
            attrs: {
              label: _vm.$t("panel.mobile_style_setting"),
              name: "style-area",
            },
          }),
        ],
        1
      ),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeName === "component-area",
              expression: "activeName === 'component-area'",
            },
          ],
          staticClass: "component-wait-main",
          style: _vm.mobileCanvasStyle,
        },
        _vm._l(_vm.pcComponentData, function (config) {
          return !config.mobileSelected && config.canvasId === "canvas-main"
            ? _c(
                "el-col",
                { key: config.id, attrs: { id: "wait" + config.id, span: 8 } },
                [_c("component-wait-item", { attrs: { config: config } })],
                1
              )
            : _vm._e()
        }),
        1
      ),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeName === "style-area",
              expression: "activeName === 'style-area'",
            },
          ],
          staticClass: "component-wait-main",
          staticStyle: { padding: "10px" },
        },
        [_c("mobile-background-selector")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }